import React from 'react';

import { Form, Switch } from 'antd';

export const PerformanceBoosterNewToggle = (props: {
  account: accountT,
  spaConnected: boolean,
  show?: boolean,
  defaultChecked?: boolean,
}) => {
  const defaultChecked = props.defaultChecked === undefined ? true : props.defaultChecked;

  return (
    <div style={{ display: 'flex', gap: '10px' }}>
      <div>
        <Form.Item hidden={!props.show} name="performanceBooster" label="Performance Booster" valuePropName="checked">
          <Switch checkedChildren="On" unCheckedChildren="Off" defaultChecked={defaultChecked} />
        </Form.Item>
      </div>
    </div>
  );
};
